/* eslint-disable camelcase */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  list: {
    fontSize: 12,
  },
  unorderedList: {
    listStyleType: 'disc',
    paddingLeft: 20,
  },
}));

const CertificationSetup = () => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}>
        To prepare for this step, open all three certificate files with Microsoft Word. Then follow the instructions
        below and click CONTINUE.
      </h4>
      <ol className={classes.list}>
        <li>In the Tera Term terminal, type 'net' and then 'cert write ca1'</li>
        <li>Type 'cert write cert1'</li>
        <ol className={classes.unorderedList}>
          <li>Copy all the text from the file "certificate.pem"</li>
          <li>Paste it into Tera Term by selecting Edit &#8594; Paste &lt;CR&gt; and then pressing Ok</li>
          <li>Ensure the text is copied in as an aligned block, without strange spacing</li>
          <li>Press Ctrl+Z to save the certificate</li>
        </ol>
      </ol>
    </div>
  );
};

export default CertificationSetup;
